<template>
  <b-modal id="modal-1" hide-footer centered v-model="show">
    <template v-slot:modal-header="{}">
      <h5>{{ $t('modalIdle.sessionExpired') }}</h5>
    </template>
    <div class="d-block text-center">
      <p>{{ $t('modalIdle.youLeftBrowserIdle', { 'idleTime': idleTime }) }}</p>
      <p>{{ $t('modalIdle.sessionTimeLeft', { 'second': second }) }}</p>
    </div>
  </b-modal>
</template>

<style lang="postcss" scoped>
</style>

<script>
import store from '@state/store';
import { refreshToken } from '../../utils/authutils';

export default {
  data() {
    return {
      time: process.env.VUE_APP_IDLE_LOGOUT * 1000,
      show: true,
    };
  },
  computed: {
    second() {
      return this.time / 1000;
    },
    idleTime() {
      return process.env.VUE_APP_IDLE_TIME / 60;
    },
  },
  methods: {
    logout() {
      this.$auth.options.logoutData.redirect = "/login";
      this.$auth.logout();
    },
  },
  beforeDestroy() {
    if (!this.$store.state.idleVue.isIdle) {
      refreshToken(store);
    }
  },
  created() {
    let timerId = setInterval(() => {
      this.time -= 1000;
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
      if (this.time < 1) {
        clearInterval(timerId);
        this.logout();
      }
    }, 1000);
  },
};
</script>
